import React, { Component } from "react";
import PeppOperationSelector from "../../crdm/PeppOperationSelector";
import { Container, FormCheck } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { closeModal } from "../../../store/actions/ModalActions";
import moment from "moment";
import { DatePicker } from "@material-ui/pickers";

const currentDate = new Date(new Date().setDate(new Date().getDate() - 1));

class InventoryDetailsViewFilter extends Component {
  state = {
    isOverall: true,
    isGenerating: false,
    isDateFilterOpen: false,
    covered_date: currentDate,
    isDateFilterFromOpen: false,
    dateFrom: currentDate,
    isDateFilterToOpen: false,
    dateTo: currentDate,
    openBy: "Overall",
    clusterId: null,
    areas: null,
    branches: [],
    isClusterMultiSelect: false,
    isAreaMultiSelect: false,
  };

  onSelectedBranchChanged = (data) => {
    this.setState({ branches: data });
  };

  onAreaChanged = (data) => {
    this.setState({ areas: data });
  };

  onClusterChanged = (data) => {
    this.setState({ clusterId: data });
  };
  onSelectedByChanged = (openBy) => {
    this.setState({ openBy: openBy });
  };

  render() {
    return (
      <Container>
        <Row>
          <Col>
            <Form className="mt-2">
              <Form.Group>
                <Form.Label>Covered Date</Form.Label>
                <Form.Control
                  className="strong"
                  onClick={() => {
                    this.setState({
                      isDateFilterOpen: true,
                    });
                  }}
                  readOnly={true}
                  value={moment(
                    this.state.covered_date !== null
                      ? this.state.covered_date
                      : new Date()
                  ).format("MMMM DD YYYY")}
                  type="text"
                />
                <Form.Text className="text-muted">
                  Click to change date.
                </Form.Text>
                <DatePicker
                  onClose={() => {
                    this.setState({ isDateFilterOpen: false });
                  }}
                  onChange={(e) => {
                    this.setState({
                      covered_date: e,
                      isDateFilterOpen: false,
                    });
                  }}
                  value={this.state.rankingPeriod}
                  maxDate={
                    new Date(new Date().setDate(new Date().getDate() - 1))
                  }
                  maxDateMessage="Max date"
                  hidden={true}
                  openTo="year"
                  views={["month", "year", "date"]}
                  format="MMMM DD YYYY"
                  open={this.state.isDateFilterOpen}
                />
              </Form.Group>
              <Form.Group>
                <FormCheck
                  label="Overall"
                  checked={this.state.isOverall}
                  onChange={(e) => {
                    this.setState({
                      isOverall: e.target.checked,
                      openBy: e.target.checked ? "Overall" : "Cluster",
                    });
                  }}
                />
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col>
            <div hidden={this.state.isOverall}>
              <PeppOperationSelector
                onSelectedBranchChanged={this.onSelectedBranchChanged}
                onSelectedByChanged={this.onSelectedByChanged}
                onClusterChanged={this.onClusterChanged}
                onAreaChanged={this.onAreaChanged}
                isClusterMultiSelect={this.state.isClusterMultiSelect}
                isAreaMultiSelect={this.state.isAreaMultiSelect}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              disabled={this.state.isGenerating}
              className="float-right mt-3"
              onClick={() => {
                switch (this.state.openBy) {
                  case "Overall":
                    this.setState({ isGenerating: true });
                    this.props
                      .getByOverall(
                        moment(this.state.covered_date).format("MMMM DD YYYY")
                      )
                      .then(() => {
                        this.setState({ isGenerating: false });
                        closeModal();
                      });
                    break;

                  case "Cluster":
                    if (this.state.clusterId) {
                      this.setState({ isGenerating: true });
                      this.props
                        .getByCluster(
                          this.state.clusterId.map((d) => d.id),
                          moment(this.state.covered_date).format("MMMM DD YYYY")
                        )
                        .then((r) => {
                          this.setState({ isGenerating: false });
                          closeModal();
                        });
                    } else {
                      alert("Please Select Cluster");
                    }
                    break;

                  case "Area":
                    if (this.state.areas) {
                      this.setState({ isGenerating: true });
                      if (
                        process.env.REACT_APP_USE_CONCURRENT_REQUEST === "true"
                      ) {
                        this.props
                          .getByAreaOptimized(
                            this.state.areas,
                            moment(this.state.covered_date).format(
                              "MMMM DD YYYY"
                            )
                          )
                          .then((r) => {
                            this.setState({ isGenerating: false });
                            closeModal();
                          });
                      } else {
                        this.props
                          .getByArea(
                            this.state.areas.map((d) => d.area_code),
                            moment(this.state.covered_date).format(
                              "MMMM DD YYYY"
                            )
                          )
                          .then((r) => {
                            this.setState({ isGenerating: false });
                            closeModal();
                          });
                      }
                    } else {
                      alert("Please Select Area");
                    }
                    break;

                  case "Branch":
                    if (this.state.branches && this.state.branches.length > 0) {
                      this.setState({ isGenerating: true });
                      this.props
                        .getByBranch(
                          this.state.branches.map((item) => item.value),
                          this.state.covered_date
                        )
                        .then((r) => {
                          this.setState({ isGenerating: false });
                          closeModal();
                        });
                    } else {
                      alert("Please Select Branch");
                    }
                    return;

                  default:
                    break;
                }
              }}
            >
              {this.state.isGenerating ? "Generating..." : "Generate Report"}
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default InventoryDetailsViewFilter;
